import { SVGInterface } from "../../interface";

const Picnic = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M22 9L12 2L2 9H11V22H13V9H22ZM12 4.44L15.66 7H8.34L12 4.44Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M4.14 12L2.18 12.37L3 16.74V22H5L5.02 18H7V22H9V16H4.9L4.14 12Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M19.1 16H15V22H17V18H18.98L19 22H21V16.74L21.82 12.37L19.86 12L19.1 16Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Picnic;
